<div class="teams-members-avatars">
  <div class="teams-members-avatars__container">
    <span class="team-members-avatars__team-length">{{ teamLength() }}</span>

    <div class="teams-members-avatars__avatars-container">
      @for (user of team()?.users?.slice(0, 4); track user?._id; let i = $index) {
        <oph-avatar
          [tooltipText]="user?.firstName + ' ' + user?.lastName"
          [tooltipPosition]="'above'"
          [isTooltipDisabled]="false"
          [ngStyle]="{'margin-left': i * AVATARS_MARGING_LEFT + 'rem'}"
          [user]="user"
          [type]="'user'"
          [size]="28"
        />
      }
      <oph-avatar
        class="teams-members-avatars__more-avatar"
        [ngStyle]="{'margin-left': team()?.users?.slice(0, 4)?.length * AVATARS_MARGING_LEFT + 'rem'}"
        [background]="'#A3A099'"
        [imgUrl]="'assets/img/icons/user-white.svg'"
        [type]="'user'"
        [imgStyle]="{width: '1rem', height: '1rem'}"
        [size]="28"
      />
    </div>
  </div>
</div>
